import * as React from 'react';
import cx from 'classnames';
import ReactSelect from "react-select";


const Select = (props) => {
  const {
    field,
    form: { touched, errors, setFieldValue, setFieldTouched },
    disabled,
    label,
    className,
    inputClassName,
    inputStep,
    inputSign,
    placeholder,
    options,
    cbChange,
    ...extra
  } = props;

  const cn = cx(className || 'input', {
    'input--err': errors[field.name],
    'input--touched': field.value,
  });

  const onChange = (option) => {
    setFieldValue(field.name, option.value);
    if (cbChange) cbChange(field, option);
  };

  return (
    <div className={cn}>
      {inputStep && <span className="input__step">{inputStep}</span>}
      {inputSign && <span className="input--sign__sign">{inputSign}</span>}
      <ReactSelect
        className={`${inputClassName || 'basic-single'}`}
        classNamePrefix={'single-select'}
        defaultValue={null}
        isDisabled={disabled}
        options={options}
        placeholder={placeholder || label}
        name={field.name}
        value={options ? options.find((option) => option.value === field.value) : ''}
        onChange={onChange}
        onBlur={() => setFieldTouched(field.name)}
        {...extra}
      />
      {label && <label className="input__lbl">{label}</label>}
      {touched[field.name] && errors[field.name] && <span className="input--err__msg">{errors[field.name]}</span>}
    </div>
  );
};

export default Select;
